import { render, staticRenderFns } from "./ProductBlockForm.vue?vue&type=template&id=01456ce2"
import script from "./ProductBlockForm.vue?vue&type=script&lang=js"
export * from "./ProductBlockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports